/* ============================================================
   工程模式面板 —— 题目调度链路自查
   ------------------------------------------------------------
   仅当 User.is_engineer_mode=true（超管自开）时,后端 v5_serving 才会在
   question.engineer_info 下发本对象。普通用户拿不到 info,组件不渲染。

   字段（与 backend/apps/assessment/v5_serving.py:_build_engineer_info 对齐）：
     · kind: library / ai / ai_fallback / unknown —— 题目来源
     · kind_label: 中文标签
     · phase: ability（测评纯能力轮，无 trait 阶段）
     · round_no: 所属轮
     · is_ai_generated: AI 是否真生成（兜底=false）
     · dimension_code/name
     · ai_status: pending / generating / ready / failed（AI 轮才有）
   ============================================================ */
import './EngineerPanel.css';

const KIND_STYLE = {
  library:     { tone: 'lib',  text: '题库选题' },
  ai:          { tone: 'ai',   text: 'AI 出题' },
  ai_fallback: { tone: 'warn', text: 'AI 失败兜底（题库）' },
  unknown:     { tone: 'gray', text: '未知来源' },
};

const AI_STATUS_LABEL = {
  pending:    '待生成',
  generating: '生成中',
  ready:      '已就绪',
  failed:     '失败（已兜底）',
};

export default function EngineerPanel({ info }) {
  if (!info) return null;
  const style = KIND_STYLE[info.kind] || KIND_STYLE.unknown;
  const groupLabel = info.dimension_name
    ? `能力 · ${info.dimension_name}（${info.dimension_code}）`
    : '—';
  const roundLabel = `R${info.round_no ?? '—'}`;

  return (
    <div className="engineer-panel">
      <div className="ep-head">
        <span className="ep-kicker">ENGINEER MODE</span>
        <span className={`ep-pill ep-pill-${style.tone}`}>{style.text}</span>
      </div>
      <ul className="ep-list">
        <li>
          <span className="ep-k">所属</span>
          <span className="ep-v">{groupLabel}</span>
        </li>
        <li>
          <span className="ep-k">轮次</span>
          <span className="ep-v mono">{roundLabel} · order={info.order_no}</span>
        </li>
        <li>
          <span className="ep-k">AI 生成</span>
          <span className="ep-v">{info.is_ai_generated ? '是' : '否'}</span>
        </li>
        {info.ai_status_key && (
          <li>
            <span className="ep-k">AI 状态</span>
            <span className="ep-v mono">
              {info.ai_status_key}={AI_STATUS_LABEL[info.ai_status] || info.ai_status || '—'}
            </span>
          </li>
        )}
        <li>
          <span className="ep-k">题目 ID</span>
          <span className="ep-v mono">#{info.question_id}</span>
        </li>
      </ul>
    </div>
  );
}
